export default __webpack_public_path__ + "static/media/monthlyCouponReport.e31fe780.png";